<div class="mp-dialog">
  <div mat-dialog-title>
    <div class="dialog-title">Bezpłatna wycena - szybki start</div>
    <button class="mp-btn tw-discreet tw-icon-only tw-small dialog-close-button contact-form-dialog-close" [attr.aria-label]="'Zamknij'" (click)="closeDialog()"><i class="fa-sharp fa-regular fa-xmark"></i></button>
  </div>
  <div mat-dialog-content>
    <div class="content-grid">
      <div class="requirements">
        <h3>Co będzie potrzebne</h3>

        <div class="divider"></div>

        <ul class="ul">
          <li>
            <span class="check" aria-hidden="true"><i class="fa-sharp fa-regular fa-check"></i></span>
            Typ mebli i przybliżone wymiary
          </li>
          <li>
            <span class="check" aria-hidden="true"><i class="fa-sharp fa-regular fa-check"></i></span>
            Dekory / kolory materiałów
          </li>
          <li>
            <span class="check" aria-hidden="true"><i class="fa-sharp fa-regular fa-check"></i></span>
            Inspiracje (zdjęcia, linki) lub projekt
          </li>
        </ul>

        <div class="divider"></div>

        <div class="hint">Porada: im więcej informacji (wymiary, styl, termin), tym dokładniejsza wycena.</div>
      </div>

      <app-contact-form (formSubmitted)="closeDialog()"></app-contact-form>
    </div>
  </div>
</div>
